/* globals $ grecaptcha Craft */

import "multiple-select";
import "multiple-select/dist/multiple-select.css";

class Forms {
  constructor() {
    this.initSelects($("form .select-container select:not(.no-init)"));
    this.initPickers($("form .datepicker:not(.no-init)"));
  }

  async getCaptchaToken(action = "submit") {
    let promise = new Promise((resolve, reject) => {
      if (typeof grecaptcha === "undefined") {
        reject(null);
      } else {
        grecaptcha.ready(() => {
          grecaptcha
            .execute(Craft.recaptchaSiteKey, { action: action })
            .then((token) => {
              resolve(token);
            })
            .catch(() => {
              reject(null);
            });
        });
      }
    });
    return promise;
  }

  disableSubmit($elem) {
    $elem.prop("disabled", true);
    if ($elem.data("label-loading")) {
      $elem.html($elem.data("label-loading"));
    }
  }

  enableSubmit($elem) {
    $elem.prop("disabled", false);
    if ($elem.data("label-submit")) {
      $elem.html($elem.data("label-submit"));
    }
  }

  initSelects($selects) {
    $.each($selects, (i, select) => {
      this.initSelect($(select));
    });
  }

  initSelect($select, options = {}) {
    if (!($select instanceof $)) {
      $select = $($select);
    }
    let parent = $select.parent();
    if (parent.hasClass("has-search-input")) {
      let $search = parent.find(".search-input");
      $search.focus((e) => {
        e.stopPropagation();
      });
      $search.click((e) => {
        e.stopPropagation();
      });
      options.onOpen = function () {
        $search.show().focus();
      };
      options.onClose = function () {
        $search.hide();
      };
    }
    let fixIcons = () => {
      $select.parent().find(".icon-caret").removeClass("hidden");
      $select.parent().find(".icon-close").addClass("hidden");
      if ($select.multipleSelect("getSelects").length) {
        $select.parent().find(".icon-caret").addClass("hidden");
        $select.parent().find(".icon-close").removeClass("hidden");
      }
    };
    if ($select.attr("multiple")) {
      options.onClick = fixIcons;
      options.onAfterCreate = fixIcons;
      options.onClear = fixIcons;
      options.onCheckAll = fixIcons;
      options.onUncheckAll = fixIcons;
    }
    options = {
      ...{
        showClear: $select.attr("multiple") == "multiple",
        selectAll: false,
      },
      ...options,
    };
    $select.multipleSelect(options);
  }

  initPickers($fields) {
    $.each($fields, (i, field) => {
      this.initPicker($(field));
    });
  }

  async initPicker($field, options = {}) {
    if (!($field instanceof $)) {
      $field = $($field);
    }
    await import(/* webpackChunkName: "flatpickr" */ "./flatpickr");
    if ($field.data("options")) {
      options = { ...$field.data("options"), ...options };
    }
    let updateClass = (val) => {
      $field.parent().find("input").last().removeClass("has-value");
      if (val.length) {
        $field.parent().find("input").last().addClass("has-value");
      }
    };
    options.onValueUpdate = updateClass;
    $field.change(() => {
      updateClass($field.val());
    });
    return $field.flatpickr(options);
  }
}

export { Forms };
